import type { FaireProductEntity } from "../../entity_types/product";

export const p_bhrubdn47g: FaireProductEntity = {
  token: "p_bhrubdn47g",
  type: "product",
  name: "Mosquito Repellent Patches | Fresh & Herbal | 90 Pack",
  brandToken: "b_hhg6www3ax",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/50e2dc488cb995f25e2482371241b8b532abec009e056e602cda9f0202e20e07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cd45f95dce03cc95032535bdc535d7982182d485bf2fefda32d033430e78621.jpeg",
    "https://cdn.faire.com/fastly/5faa20e463fe37e90dd4eb5d96397c94d331a15e938586c776894db0d7e243a2.jpeg",
    "https://cdn.faire.com/fastly/727d9ae6237a9231351eff542db2042921ced61eaecd6f2d455db62059fbccd7.jpeg",
    "https://cdn.faire.com/fastly/3e7c50a5fb871f483386a691803005ad9c11b9bd580aadba7db98e1574d72579.jpeg",
    "https://cdn.faire.com/fastly/26142b131bb3b8fef32d30bb0d182e7be5e36124ee3946ffac8fb8dc12ef4d9e.jpeg",
    "https://cdn.faire.com/fastly/7ae4c1c067f5aff4085257ba0b66e5a42c560718562de590ac2321145f2f845c.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "Luna Naturals Mosquito Repellent Patches – Natural, DEET-Free Protection for Spring & Summer\n\nEnjoy the outdoors without mosquito bites with Luna Naturals Mosquito Repellent Patches. As warmer weather brings bugs back, these plant-powered, DEET-free patches provide effective protection for up to 24 hours—no sprays, lotions, or skin application needed. Simply stick and go for worry-free outdoor fun.\n\nWhy They’re a Must-Have This Season:\n\n• Natural & Non-Toxic Protection – Made with plant-based essential oils like citronella and peppermint, free from harsh chemicals.\n• Up to 24-Hour Defense – Each patch offers long-lasting mosquito repellency, perfect for day trips and overnight adventures.\n• Easy Stick-On Use – Attach to clothing, hats, backpacks, strollers, or gear for hassle-free protection.\n• Mess-Free & Travel-Friendly – No greasy sprays or sticky lotions. Great for kids, adults, and families on the go.\n• Perfect for Spring & Summer Activities – Ideal for camping, hiking, travel, backyard play, picnics, and festivals.\n• Family Value Pack – Includes 90 patches, ensuring plenty of protection for multiple outings.\n\nBe ready for mosquito season—Luna Naturals Mosquito Repellent Patches make natural protection simple, safe, and convenient wherever you go.",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:16.233Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
